import React from 'react';
import './css/contact/footer.css';


function Footer() {
  return (
    <>
      <div className="footer align-middle">
        <div id="footfirst">
          <div className="row">
            <div className="col-12">
              <h2 className="text-center">
                This could be the beginning of a <br />
                beautiful relationship
              </h2>
              <div className="text-center footer-plus">

                <div className="ianimatored text-center">
                  <a style={{ color: '#fff' }} target="_blank" href="/start-your-project" className="ianimatored footnewtest animated">
                    Start a project
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="footersocial">
          <div className>
            <div className="row " style={{justifyContent: 'center'}}>
              <div className="col-md-1 col-sm-0 col-0"></div>
              <div className="col-md-1 col-sm-0 col-0"></div>
              <div className="col-md-1 col-sm-0 col-1"></div>
              <div className="col-md-1 col-1">
                <a href={"https://www.facebook.com/rspasansol?mibextid=LQQJ4d"} target='_blank'>
                  <i className="fa fa-facebook sofirst" aria-hidden="true"></i>
                </a>
              </div>
              <div className="col-md-1 col-1">
                <a href={"https://www.instagram.com/ranisatiply.asn/?igshid=MzRlODBiNWFlZA%3D%3D"} target='_blank'>
                  <i className="fa fa-instagram sosec" aria-hidden="true"></i>
                </a>
              </div>
              {/* <div className="col-md-1 col-1">
                <a href={""}>
                  <i className="fa fa-twitter sothree" aria-hidden="true"></i>
                </a>
              </div>
              <div className="col-md-1 col-1">
                <a href={""}>
                  <i className="fa fa-pinterest-p sofour" aria-hidden="true"></i>
                </a>
              </div>
              <div className="col-md-1 col-1 ">
                <a href={""}>
                  <i className="fa fa-youtube-play sosix" aria-hidden="true"></i>
                </a>
              </div>
              <div className="col-md-1 col-1 ">
                <a href={""}>
                  <i className="fa fa-linkedin soeight" aria-hidden="true"></i>
                </a>
              </div> */}
              <div className="col-md-1 col-sm-0  col-1"></div>
              <div className="col-md-1 col-sm-0  col-0"></div>
              <div className="col-md-1 col-sm-0 col-0"></div>
            </div>
          </div>
        </div>
        <div id="footermiddle">
          <div className="container">
            <div className="row footwrite">
              <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="row myfoot" style={{ paddingLeft: '20px' }}>
                  <div className="col-6">
                    <b>ABOUT</b> <br /><br />
                    <a href="/howitworks">How it Works</a> <br />
                    <a href="/contact">Contact</a> <br />
                  </div>
                  <div className="col-6">
                    <b>OUR DESIGNS</b> <br /><br />
                    <a href="/products/">Products</a> <br />
                    <a href="/interior-design/">Our Designs</a> <br />
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-12 col-sm-12 col-12 footer-details-rev-last">
                <div className="row r-rev-paddig-f">

                  <div className="col-lg-2  col-12 footer-cions-rev">
                    <img src="/img/phone_icon.png" alt="Contact Ranisati" />
                  </div>

                  <div className="col-lg-10 col-12  rev-all-inc">
                    <div className="row">
                      <div className="col-12 footer-rev-title">
                        <small className>Call us anytime</small>
                      </div>
                      <div className="col-12 footer-rev-details">
                        <a href="tel:+919933332263">+91-9933332263</a><br/>
                        <a href="tel:+919800144511">+91-9800144511</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row r-rev-paddig">

                  <div className="col-lg-2  col-12 footer-cions-rev">
                    <img src="/img/chatimage.png" alt="Contact Ranisati" />
                  </div>

                  <div className="col-lg-10 col-12  rev-all-inc">
                    <div className="row">
                      <div className="col-12 footer-rev-title">
                        <small className>Chat with us</small>
                      </div>
                      <div className="col-12 footer-rev-details">
                        <a href="https://wa.me/c/919933332263" target=" _blank">right here!</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row r-rev-paddig">

                  <div className="col-lg-2  col-12 footer-cions-rev">
                    <img src="/img/emailogo.png" alt="Contact Ranisati" />
                  </div>

                  <div className="col-lg-10 col-12 rev-all-inc">
                    <div className="row">
                      <div className="col-12 footer-rev-title">
                        <small className>Write us at</small>
                      </div>
                      <div className="col-12 footer-rev-details">
                        <a href="mailto:ranisatiply@yahoo.com"><span className="__cf_email__" data-cfemail="f59c9b939ab5979980909894869a9b86db969a98">ranisatiply@yahoo.com</span></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12" align="bottom">
              <center>

                <img src="/img/foot-logo.png" alt="Contact Ranisati" />
              </center>
            </div>
          </div>
        </div>
        <div id="seo_title">
        </div>
        <div id="LastSectionFooter">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 col-12">
                <div className="pull-left">
                  <p style={{ color: 'black' }}>Address:  45/46, G. T. Road- East, Beside Icici Bank, Durga Mandir, Asansol, West Bengal, PIN - 713303</p>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="pull-right">
                  <p style={{ color: 'black' }}>Copyright © 2023. Ranisati Ply & Hardware. All Rights Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p style={{ fontSize: '15px', color: 'black', backgroundColor: 'white', marginTop: '2px', marginBottom: '0px', paddingTop: '5px', paddingBottom: '5px', display: 'block', textAlign: 'center', fontWeight: 'bold' }}>Designed by SmallTownTalks</p>
      </div>
    </>
  );
}
export default Footer;
